
export const rem = px => Number(px) ? `${Number(px) / 16}rem` : 0;
